export { default } from 'shared/components/list'
